var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_309_1084",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_309_1084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 9.20833H7.04166V5.95834H5.95833V9.20833ZM6.49999 4.875C6.65347 4.875 6.78211 4.82309 6.88593 4.71927C6.98975 4.61545 7.04166 4.48681 7.04166 4.33334C7.04166 4.17986 6.98975 4.05122 6.88593 3.9474C6.78211 3.84358 6.65347 3.79167 6.49999 3.79167C6.34652 3.79167 6.21788 3.84358 6.11406 3.9474C6.01024 4.05122 5.95833 4.17986 5.95833 4.33334C5.95833 4.48681 6.01024 4.61545 6.11406 4.71927C6.21788 4.82309 6.34652 4.875 6.49999 4.875ZM6.49999 11.9167C5.75069 11.9167 5.04652 11.7745 4.38749 11.4901C3.72847 11.2057 3.1552 10.8198 2.6677 10.3323C2.1802 9.84479 1.79427 9.27153 1.50989 8.6125C1.22552 7.95347 1.08333 7.24931 1.08333 6.5C1.08333 5.7507 1.22552 5.04653 1.50989 4.3875C1.79427 3.72847 2.1802 3.15521 2.6677 2.66771C3.1552 2.18021 3.72847 1.79427 4.38749 1.5099C5.04652 1.22552 5.75069 1.08334 6.49999 1.08334C7.2493 1.08334 7.95347 1.22552 8.61249 1.5099C9.27152 1.79427 9.84479 2.18021 10.3323 2.66771C10.8198 3.15521 11.2057 3.72847 11.4901 4.3875C11.7745 5.04653 11.9167 5.7507 11.9167 6.5C11.9167 7.24931 11.7745 7.95347 11.4901 8.6125C11.2057 9.27153 10.8198 9.84479 10.3323 10.3323C9.84479 10.8198 9.27152 11.2057 8.61249 11.4901C7.95347 11.7745 7.2493 11.9167 6.49999 11.9167Z",
    fill: "#F59E0C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/infoFilled.4ba7b4f9981c2b5d1bde481cc132c271.svg";
export { ForwardRef as ReactComponent };